import * as React from 'react';
import { forwardRef } from 'react';
import type { Ref } from 'react';

import type { IconProps } from '../../Icon';
import { Icon } from '../../Icon';
function SvgSortAlphabeticalLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
      <g fill="currentColor" clipPath="url(#SortAlphabeticalLeftIcon_svg__a)">
        <path d="M.94 4 4.97-.03l1.06 1.06-2.22 2.22H10v1.5H3.81l2.22 2.22-1.06 1.06L.94 4Z" />
        <path
          fillRule="evenodd"
          d="M4.307 9a.75.75 0 0 1 .697.473L7.596 16H5.982l-.238-.6H2.855l-.24.6H1l2.61-6.528A.75.75 0 0 1 4.307 9Zm-.852 4.9h1.693l-.844-2.124-.849 2.124Z"
          clipRule="evenodd"
        />
        <path d="M11.777 10.5H8.5V9h4.75a.75.75 0 0 1 .607 1.191L10.723 14.5H14V16H9.25a.75.75 0 0 1-.607-1.191l3.134-4.309Z" />
      </g>
      <defs>
        <clipPath id="SortAlphabeticalLeftIcon_svg__a">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const SortAlphabeticalLeftIcon = forwardRef((props: IconProps, forwardedRef?: Ref<HTMLSpanElement>) => {
  return <Icon ref={forwardedRef} {...props} component={SvgSortAlphabeticalLeftIcon} />;
});
SortAlphabeticalLeftIcon.displayName = 'SortAlphabeticalLeftIcon';
export default SortAlphabeticalLeftIcon;
